import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'swb-no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss']
})
export class NoDataComponent implements OnInit {

  @Input()
  public text = 'Zatím tu nic není. Zkuste něco přidat.';

  constructor() { }

  ngOnInit() {
  }

}
